'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularAnimate = require('angular-animate');

var _angularAnimate2 = _interopRequireDefault(_angularAnimate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('thingsboard.directives.noAnimate', [_angularAnimate2.default]).directive('tbNoAnimate', NoAnimate).name;

/*@ngInject*/
/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function NoAnimate($animate) {
    return {
        restrict: 'A',
        link: function link(scope, element) {
            $animate.enabled(element, false);
            scope.$watch(function () {
                $animate.enabled(element, false);
            });
        }
    };
}


// WEBPACK FOOTER //
// ./src/app/components/no-animate.directive.js